import { z } from "zod";

export const CreateLetterFormSchema = z.object({
  ladyId: z.string().refine((val) => !isNaN(parseInt(val, 10)), {
    message: "Oops! ID should be a numeric value.",
  }),
  letterText: z
    .string()
    .trim()
    .min(
      1,
      "It looks like your letter is empty. Please write something before sending.",
    ),
});

export type CreateLetterFormSchema = z.infer<typeof CreateLetterFormSchema>;
